import { Injectable } from "@angular/core";
import { AuthService } from "src/app/auth/auth.service";
import { KioskAffiliatedUserDto } from "src/openapi-gen/models";

@Injectable({
  providedIn: "root",
})
export class KioskUserService {
  constructor(private authorizedUserService: AuthService) {}

  saveAffiliatedUser(data: KioskAffiliatedUserDto) {
    this.authorizedUserService.saveAffiliatedUser(data);
  }

  getAffiliatedUser(): KioskAffiliatedUserDto {
    return this.authorizedUserService.getAffiliatedUser();
  }

  clearSelection() {
    this.authorizedUserService.clearAffiliatedUser();
  }
}